import ModalStack from '@/components/Custom/ModalStack';

export default function PrivateEventShareLayoutRoute() {
  return <ModalStack />;
}
